import {
  type DashboardActions,
  InternalMembersActions,
} from '@store/reducers/dashboard/actions'
import type { TeammateDto } from '@store/reducers/dashboard/types'
import { GeneralErrorNotification } from '@storeOld/reducers/notification'
import { call, put } from 'redux-saga/effects'

import { GtmTriggerName, sendGtmEvent } from '@/constants/gtm'
import { NestClient } from '@/nest'

export function* invite({
  payload: { workspaceId, email },
}: ReturnType<typeof DashboardActions.members.invite>) {
  const placeholderId = Date.now().toString(16)
  const item: TeammateDto = {
    avatar: null,
    color: 'collab-10',
    name: 'Pending...',
    activity: 'pending',
    role: 'MEMBER',
    id: placeholderId,
    email,
  }

  yield put(InternalMembersActions.push({ workspaceId, item }))
  try {
    yield call(NestClient.membership.add, workspaceId, {
      emailAddress: email,
    })
    yield call(sendGtmEvent, GtmTriggerName.TEAM_INVITE)
  } catch (e) {
    console.error('Error while inviting member', e)
    yield put(GeneralErrorNotification)
  }
  yield put(InternalMembersActions.fetchList({ workspaceId }))
}
